
import TheNavbar from "@/components/TheNavbar.vue";
import MapboxMap from "@/components/map/MapboxMap.vue";
import LeftSidebar from "@/components/drawers/left/LeftSidebar.vue";
import RightSidebar from "@/components/drawers/right/RightSidebar.vue";
import BottomDrawer from "@/components/drawers/bottom/BottomDrawer.vue";
import TermsAndConditions from "@/components/TermsAndConditions.vue";
import StreetViewModal from "@/components/modals/StreetViewModal.vue";
import BookUploadModal from "@/components/modals/BookUploaderModal/BookUploadModal.vue";
import ShareLink from "@/components/modals/ShareLink.vue";
import PrintModal from "@/components/modals/PrintModal.vue";
import PermissionChangedModal from "@/components/modals/PermissionChangedModal.vue";
import {
  useAuth,
  useLayout,
  useLocation,
  useMap,
  useOrgSettings,
} from "@/services";
import { mapState } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",
  components: {
    StreetViewModal,
    ShareLink,
    TermsAndConditions,
    TheNavbar,
    MapboxMap,
    LeftSidebar,
    RightSidebar,
    BottomDrawer,
    PrintModal,
    PermissionChangedModal,
    BookUploadModal,
  },
  data: () => ({
    isTcVisible: false,
  }),
  computed: {
    ...mapState(useLayout, [
      "isPageLoading",
      "page",
      "isRightSidebarOpen",
      "isLeftSidebarOpen",
      "isMapPage",
    ]),
    ...mapState(useAuth, ["isLoggedIn", "isInstanceReady", "accessToken"]),
    ...mapState(useMap, ["isMapLoading"]),
    pageStyle(): any {
      return {
        backgroundColor: this.isMapPage ? "transparent" : "#fdfdfd",
        pointerEvents: this.isMapPage ? "none" : "all",
      };
    },
    isLoading(): boolean {
      return !this.isLoggedIn || this.isPageLoading;
    },
    appClasses(): Record<string, boolean> {
      return {
        [`page-${this.page}`]: true,
        isLsOpen: this.isLeftSidebarOpen,
        isRsOpen: this.isRightSidebarOpen,
      };
    },
  },
  watch: {
    accessToken: {
      handler(val) {
        if (val) {
          useOrgSettings()
            .fetchOrganisationSettings()
            .then(() => document.body.classList.remove("loading"));

          useLocation().loadLocationsFromLocalStorage();
        }
      },
      immediate: true,
    },
  },
  created() {
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true,
    });
  },
  mounted() {
    this.$nextTick(() => {
      const searchInput = (this.$refs.app as Element)?.querySelector(
        ".address-search input"
      );
      if (searchInput instanceof HTMLInputElement) {
        searchInput.focus();
      }
    });
    this.$bus.$on("scroll:top", () => {
      (this.$refs.scrollbarRef as any)?.$el.scroll(0, 0);
      (this.$refs.scrollbarRef as any)?.update();
    });
  },
  methods: {
    onTcClose() {
      this.isTcVisible = false;
    },
    updateAvailable() {
      this.$bvToast.show("newUpdate");
    },
    refreshApp() {
      window.location.reload();
    },
  },
});
